/* eslint-disable vue/require-v-for-key */
<template>
  <div class="mx-4" v-resize="onResize" ref="mainDiv">
    <div
      class="mb-4"
      :class="$vuetify.breakpoint.xs ? 'text-h6 mt-4' : 'text-h5 mt-5'">
      <v-icon :large="!$vuetify.breakpoint.xs">
       mdi-magnify
      </v-icon>
     Bird Lookup
    </div>
    <v-row>
      <v-col cols="12" sm="2">
        <v-select
          v-model="pedFilter"
          clearable
          label="Pedigree"
          :items="['yes','no']"
        />
      </v-col>
      <v-col cols="12" sm="2">
        <v-select
          v-model="houseFilter"
          clearable
          label="House"
          :items="houses"
        />
      </v-col>
      <v-col cols="12" sm="2">
        <v-select
          v-model="lineFilter"
          clearable
          label="Line"
          :items="lines"
        />
      </v-col>
      <v-col cols="12" sm="2">
        <v-combobox
          v-model="badgeFilter"
          clearable
          label="Badge"
          :items="badges"
        />
      </v-col>
      <v-col cols="12" sm="2">
        <v-combobox
          v-model="wingbandFilter"
          clearable
          label="Wingband"
          :items="wingbands"
        />
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn
          size="small"
          class="mt-3"
          @click="houseFilter = null; lineFilter = null; badgeFilter = null; wingbandFilter = null; pedFilter = null"
          color="primary"
          dark
        >
          Clear Filters
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      class="pl-4 elevation-1 cardbackground"
      :height="tableHeight"
      mobile-breakpoint="300"
      multi-sort
      dense
      :headers="badgeHeaders"
      :items="filteredBirds"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  //name: 'Metadata',
  components: {
  },
  data() {
    return {
      birds: null,
      houses: null,
      houseFilter: null,
      lines: null,
      lineFilter: null,
      badges: null,
      badgeFilter: null,
      wingbands: null,
      wingbandFilter: null,
      pedFilter: null,
      windowSize: {x: 0,y: 0}
    }
  },
  mounted () {
    this.onResize();
    this.$refs.mainDiv.scrollIntoView();
  },
  async created() {
    try {
      this.birds = JSON.parse(JSON.stringify(this.settings.badges));
      this.birds.forEach(b => {
        b.line = (b.line ? 'L' + b.line : b.line);
        b.isPedigree = (b.isPedigree ? 'yes' : 'no');
      });
      this.lines = [...new Set(this.birds.map(b => b.line))].sort();
      this.houses = [...new Set(this.birds.map(b => b.houseCode))].sort();
      this.badges = [...new Set(this.birds.map(b => b.badgeCode))].sort();
      this.wingbands = [...new Set(this.birds.map(b => b.wingband))].sort();
    } catch(error) {
      this.$root.showNoticeError(error.message);
    }
  },
  computed: {
    ...mapState(['settings']),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    badgeHeaders() {
      const tableCols = [
        { text: 'Farm', value: 'farmCode', align: 'start', sortable: false },
        { text: 'House', value: 'houseCode' },
        { text: 'Line', value: 'line' },
        { text: 'Badge', value: 'badgeCode' },
        { text: 'Ped', value: 'isPedigree'},
        { text: 'Wingband', value: 'wingband'}
      ];
      return tableCols;
    },
    filteredBirds: {
      get() {
        var filteredBirds = this.birds;

        if (this.houseFilter != null) {
          filteredBirds = filteredBirds.filter(b => b.houseCode == (this.houseFilter));
        }
        if (this.lineFilter != null) {
          filteredBirds = filteredBirds.filter(b => b.line == (this.lineFilter));
        }
        if (this.badgeFilter != null) {
          filteredBirds = filteredBirds.filter(b => b.badgeCode == (this.badgeFilter));
        }
        if (this.wingbandFilter != null) {
          filteredBirds = filteredBirds.filter(b => b.wingband == (this.wingbandFilter));
        }
        if (this.pedFilter != null) {
          filteredBirds = filteredBirds.filter(b => b.isPedigree == (this.pedFilter));
        }

        return filteredBirds;
      }
    },
    tableHeight() {
        let tableSize = this.windowSize.y - 280;

        if (this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name === 'sm') {
          tableSize += 4; // v-app-bar shorter for xs and sm
        }
        if (tableSize < 200) tableSize = 200;
        return tableSize;
      }
  },
  methods: {
    onResize() {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      },
    formatDate(dt) {
      if (!dt) return null;
      let fdt = new Date(dt).toLocaleString();
      fdt = fdt.replace(',','');
      return fdt;
    }
  }
}
</script>